import styled from "styled-components";
import { tint, shade } from "polished";

const VARIANTS = {
  info: "#4e8ff5",
  danger: "#ff0448"
};

const Alert = styled.div`
  font-size: 14px;
  padding: 10px 15px;
  border-left: 4px solid #000;
  border-radius: 4px;
  background: ${props => tint(0.25, VARIANTS[props.variant])};
  border-color: ${props => VARIANTS[props.variant]};
  color: ${props => shade(0.7, VARIANTS[props.variant])};
`;

Alert.defaultProps = {
  variant: "danger"
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert.js